import { Row } from "antd";
import styled from "styled-components";

export const LoginWrapper = styled(Row)`
  font-family: Roboto Flex;
  color: var(--PRIMARY) !important;
  .large-btn {
    height: 5.6rem;
    margin-top: 1.6rem;
    font-weight: 600;
    font-size: 1.7rem;
  }

  p {
    font-size: 18px;
    font-weight: 100;
    color: var(--SECONDARY);
    margin-bottom: 0;
    margin-top: 12px;
  }
  h4 {
    font-size: 28px;
    margin: 0;
    color: var(--PRIMARY);
  }
  .login {
    width: 510px;
    padding: 44px 48px;
    display: flex;
    flex-direction: column;
    gap: 32px;
    background-color: var(--BACKGROUND-PRIMARY);
    border: 1px solid rgba(20, 45, 80, 0.25);
    border-radius: 24px;
    height: 100%;
    box-shadow: 0px 20px 24px -4px #10182814;

    button {
      padding: 18px 122px;
      height: 56px;
      background: white !important;
      box-shadow:
        0px 2.55px 5.95px 0px rgba(0, 0, 0, 0.05),
        0px 10.48px 10.48px 0px rgba(0, 0, 0, 0.07) !important;
    }
  }

  .error {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 13px 18px;
    background-color: #ff869ac2;
    border-radius: 6px;
    p {
      font-size: 14px !important;
      margin: 0;
      color: #2b0606;
      font-weight: 100;
    }
  }
`;

export const PasswordVisibilityToggleWrapper = styled.span`
  display: inherit;
`;

export const ActionText = styled.div<{ $align: string }>`
  color: var(--PRIMARY);
  font-size: 1.4rem;
  margin-top: 2rem;
  text-align: ${(props) => props?.$align};
  font-weight: 600;
  cursor: pointer;
  .text {
    margin-left: 10px;
    font-size: 1.6rem;
  }
`;
